import React, { Component } from 'react'

class Product extends Component{
  constructor() {
    super();
    this.state = {
      id: null,
      title: '',
      article_number: '',
      image: '',
      packet: '',
      price: '',
      description: '',
      cl: '',
      vat: '',
      success: false
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getProduct = this.getProduct.bind(this)
  }

  handleSubmit(event){
    event.preventDefault()
    const product = {product: {...this.state}}
    const token = localStorage.getItem("admin-token")
    const body = JSON.stringify(product)
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/product/${this.state.id}`,
      {
        headers,
        body,
        method: "POST"
      })
      .then(res => {
        if (res.status === 200) {
          this.setState({success: true})
        }  else {
          console.log("Server Error!");
        }
      })
  }

  getProduct(){
    const product_id = this.props.match.params.id
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/product/${product_id}`, {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(json_res => {
            this.setState({...json_res})
          })
        }  else {
          console.log("Server Error!");
        }
      })
  }

  handleInputChange(event) {
    const name = event.target.name;
    const value = event.target.value

    this.setState({
      [name]: value
    });
  }

  componentDidMount() {
    this.getProduct()
  }

  render() {
    return(
      <div className="Admin-Product">
        <h1>Product - {this.state.article_number}</h1>
        {
          this.state.success
          ?
          <p className="Admin-Product-success">Produkten har uppdaterats</p>
          :
          null
        }
        <div className="Admin-Product-btn">
          <button
            className="white"
            onClick={this.getProduct}>
            Reset
          </button>
          <button onClick={this.handleSubmit}>Spara</button>
        </div>
        <div className="Products-body">
          <form onSubmit={this.handleSubmit}>
            <label className="form-label">
              Titel
            </label>
            <input
              type="text"
              placeholder="Titel"
              className="form-input"
              value={this.state.title}
              onChange={this.handleInputChange}
              name="title"/>
            <label className="form-label">
              Artikel nummer
            </label>
            <input
              type="number"
              placeholder="Artikel nummer"
              className="form-input"
              value={this.state.article_number}
              onChange={this.handleInputChange}
              name="article_number"/>
            <label className="form-label">
              Bild (url)
            </label>
            <input
              type="text"
              placeholder="Bild"
              className="form-input"
              value={this.state.image}
              onChange={this.handleInputChange}
              name="image" />
            <label className="form-label" >
              Beskrivning
            </label>
            <textarea
              rows="5"
              className="form-input"
              placeholder="Beskrivning"
              value={this.state.description}
              onChange={this.handleInputChange}
              name="description"
              />
            <label className="form-label">
              Pris (ink moms)
            </label>
            <input
              type="number"
              placeholder="Pris"
              className="form-input"
              value={this.state.price}
              onChange={this.handleInputChange}
              name="price"/>
            <label className="form-label">
              Moms
            </label>
            <input
              type="number"
              placeholder="Moms"
              className="form-input"
              value={this.state.vat}
              onChange={this.handleInputChange}
              name="vat"/>
            <label className="form-label">
              Cl (total)
            </label>
            <input
              type="number"
              placeholder="Cl"
              className="form-input"
              value={this.state.cl}
              onChange={this.handleInputChange}
              name="cl"/>
            <label className="form-label">
              Packets
            </label>
            <input
              type="number"
              placeholder="Packets"
              className="form-input"
              value={this.state.packet}
              onChange={this.handleInputChange}
              name="packet"/>
          </form>
        </div>
      </div>
    )
  }
}

export default Product



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Product.jsx